import React, { useEffect, useMemo, useState } from "react";
import {
  BrowserRouter,
  HashRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
  redirect,
  useSearchParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "../src/styles/App.css";
import "./i18n/i18n";

import ProgressBlock from "./components/ProgressBlock/ProgressBlock";
import { common_route, routes, rules_route } from "./utils/routes";
import OverflowHidden from "./utils/OverflowHidden";
import ShouldHideMenu from "./utils/hideMenu";
import { installStandaloneViewportFix } from "./utils/standaloneViewportFix";
import useDeviceType from "./hook/useDeviceType";
import { API_RELOAD, WEB_LAYOUT } from "./constant";
import { BasicApi } from "./api/basicApi";
import CommonHelmet from "./components/Seo/commonHelmet";
import "../src/styles/splide.css";
import DescriptionDashboard from "./pages/Game/gameDescription/descriptionDashboard";
import { ErrorBoundary } from "react-error-boundary";
import WalletSetting from "./components/SignInUp/components/WalletSetting";
import { getEventList } from "./api/getApi";
import ColorModePage from "./pages/Settings/components/colorModePage";
import PageProgress from "./components/ProgressBlock/PageProgress";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import LiveChat from "./components/LiveChat/LiveChat";
import GoogleNotification from "./pages/Singin/components/GoogleNotification";
import axios from "axios";
import ReactGA from "react-ga4";
import StatusModal from "./pages/StatusModal/StatusModal";
import LoadingPage from "./components/Loading/LoadingPage";
import Cookies from "js-cookie";
import { Box, useColorMode } from "@chakra-ui/react";
import useCheckLogin from "./hook/useCheckLogin";
import StartGameButton from "./pages/Home/StartGameButton";
import EarnMoneyFromSocket from "./pages/WebSocket/EarnMoneyFromSocket";
import AudioPlayer from "./components/AudioPlayer/AudioPlayer";
import LossPointModal from "./components/LossPoint/LossPointModal";
import AgeCheckModal from "./components/AgeCheck/AgeCheckModal";
import LineCustomerModal from "./components/LineCustomerModal/LineCustomerModal";
import MaintainAlertModal from "./components/MaintainAlertModal/MaintainAlertModal";
import LanguagePage from "./pages/Settings/components/LanguagePage";
import AnnouncementModal from "./components/AnnouncementModal/components/AnnouncementModal";

function App() {
  const { i18n } = useTranslation();

  const dispatch = useDispatch();
  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  const navigate = useNavigate();
  const location = useLocation();

  const deviceType = useDeviceType();
  const hideMenu = ShouldHideMenu();

  const { lang } = useParams();

  const { isLogin, isMachineUser } = useCheckLogin();

  const locationChanger = useMemo(() => {
    if (location.pathname?.includes("profile")) {
      return false;
    } else {
      return location.key;
    }
  }, [location]);
  const [searchParams, setSearchParams] = useSearchParams();

  const token = searchParams.get("token");

  const { setColorMode } = useColorMode();
  useEffect(() => {
    setColorMode("dark");
  }, [setColorMode]);

  useEffect(() => {
    const className = "dark";
    const bodyClasses = document.body.classList;

    isDarkMode ? bodyClasses.add(className) : bodyClasses.remove(className);
  }, [isDarkMode]);

  /* iOS PWA standalone 轉向後會帶著一段虛假的負捲動位移(實測 -59px,
     等於橫向的 safe-area inset),害 position:fixed 的繪製位置與觸控命中區
     差開來 —— 使用者會覺得「觸發點在手指上方」。
     掛在根元件 App:它涵蓋整個路由表,包含獨立的 /gamebox 遊戲頁。
     只在 standalone 生效,一般瀏覽器分頁不受影響。詳見該模組註解。 */
  useEffect(() => installStandaloneViewportFix(), []);

  useEffect(() => {
    BasicApi(dispatch)();
    if (token) {
      Cookies.set("token", token, { expires: 365 });
    }
    dispatch({ type: "INITIALIZE_API", navigate: navigate });
  }, []);

  const languagePop = useSelector((state) => state.isLanguagePop);
  const walletSettingPop = useSelector((state) => state.isWalletSettingPop);
  const comissionListPop = useSelector((state) => state.isComissionListPop);
  const colorTab = useSelector((state) => state.isColorMode);
  const isGameDescriptionConfig = useSelector(
    (state) => state.isGameDescriptionPop,
  );

  useEffect(() => {
    const fetchDataPeriodically = () => {
      dispatch({ type: "UPDATE_DATA_PERIODICALLY", navigate: navigate });
      // dispatch({ type: "CURRENCY_EXCHANGER" });
    };

    const apiIterval = setInterval(() => {
      fetchDataPeriodically();
    }, API_RELOAD);

    return () => clearInterval(apiIterval);
  }, []);

  const ROUTES = [...rules_route, ...routes];

  useEffect(() => {
    //記住代理邀請碼
    const searchParams = new URLSearchParams(location.search);
    const currentInviteParams = searchParams.get("invite");
    if (currentInviteParams) {
      Cookies.set("invite", currentInviteParams, { expires: 1 / 48 });
    }
  }, [location]);

  return (
    <ErrorBoundary fallback={<div>&nbsp;</div>}>
      <EarnMoneyFromSocket />
      <GoogleNotification />
      <CommonHelmet />
      <Box
        // bgImage={`url(${BG_MASK})`}
        // bgSize={`auto`}
        className={`${
          deviceType === "PC"
            ? hideMenu
              ? " w-full"
              : "pl-[320px] w-full"
            : ""
        }`}
      >
        {/* <PageProgress key={locationChanger} /> */}

        <Routes location={location}>
          {ROUTES?.filter((route) => !route.hidden)?.map((route, index) => {
            return (
              <Route
                key={route.path}
                path={`${route.path}`}
                element={route.element}
              >
                {common_route
                  ?.filter((route) => !route.hidden)
                  ?.map((child, index) => {
                    return (
                      <Route
                        key={child.path}
                        exact={child.exact}
                        path={`${child.path}`}
                        element={
                          <OverflowHidden>
                            {child.element}
                            <Outlet key={child.path} />
                          </OverflowHidden>
                        }
                      >
                        {child.children?.map((item) => {
                          return (
                            <Route
                              exact={item.exact}
                              key={item.path}
                              path={`${item.path}`}
                              element={
                                <>
                                  {item.element}
                                  <Outlet />
                                </>
                              }
                            />
                          );
                        })}
                      </Route>
                    );
                  })}
              </Route>
            );
          })}
          <Route path="*" element={<Navigate to={`/`} />} />
        </Routes>
      </Box>

      {/* 未登入 且判斷是機台 顯示全螢幕半透明黑色背景 讓他按開始遊戲 */}
      {!isLogin && isMachineUser && <StartGameButton />}
      {!isMachineUser && <AgeCheckModal />}
      <ProgressBlock />
      {colorTab && <ColorModePage />}
      {languagePop && <LanguagePage />}
      {walletSettingPop && <WalletSetting />}
      {isGameDescriptionConfig?.state === true && <DescriptionDashboard />}
      <LoadingPage />
      {process.env.REACT_APP_LIVECHAT_OPEN == "1" ? <LiveChat /> : null}
      <StatusModal />
      <AudioPlayer />
      {/* 輸分已達到，不可充值彈窗 */}
      <LossPointModal />
      {/* <LineCustomerModal /> */}
      <MaintainAlertModal />
      <AnnouncementModal />
    </ErrorBoundary>
  );
}

export default React.memo(App);
